import React from 'react';
import PropTypes from 'prop-types';
import styles from './price.module.scss';

const Price = (props) => (
	<div className={`${styles.price} w-full ${props.className || ''}`}>
		{props.price && (
			<>
				{props.priceHeading && (
					<p className={`priceHeading mb-1 leading-tight`}>
						<span className='bg-primary px-2 py-0.5 text-sm font-semibold uppercase text-black'>{props.priceHeading}</span>
					</p>
				)}
				<span className={`${styles.price_formatted} mr-1 font-bold leading-none md:mr-2`}>
					{props.pricePrefix}
					{props.price.formatted}
				</span>
				{props?.priceComparison?.formatted && <span className={`${styles.priceComparison_formatted} mr-3 mt-0 inline text-lg !leading-none text-neutral-600 lg:text-2xl`}>{props.priceComparison.formatted}</span>}
				{props.priceAsText && <p className={`${styles.priceAsText} uppercase leading-tight text-neutral`}>{props.priceAsText}</p>}
			</>
		)}
	</div>
);

Price.propTypes = {
	price: PropTypes.object,
	priceComparison: PropTypes.object,
	priceHeading: PropTypes.string,
	className: PropTypes.string,
	priceAsText: PropTypes.string,
	pricePrefix: PropTypes.string,
};

export default Price;
